import {
  ApiBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

import { rootRouteRef } from './routes';
import { deploymentsApiRef } from './api/types.ts';
import { DeploymentsClient } from './api/DeploymentsClient.ts';

const deploymentsApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: deploymentsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new DeploymentsClient({ discoveryApi, fetchApi }),
    }),
});

const deploymentsPage = PageBlueprint.make({
  params: {
    path: '/deployments',
    title: 'Deployments',
    routeRef: rootRouteRef,
    // The page renders its own BUI Header above the deployment matrix.
    noHeader: true,
    loader: () =>
      import('./components/DeploymentsComponent.tsx').then(m => (
        <m.DeploymentsComponent />
      )),
  },
});

export const deploymentsPlugin = createFrontendPlugin({
  pluginId: 'deployments',
  title: 'Deployments',
  routes: {
    root: rootRouteRef,
  },
  extensions: [deploymentsApi, deploymentsPage],
});

export default deploymentsPlugin;
